export enum StatisticsTab {
  Trades = 'Trades::StatisticsTab',
  Holdings = 'Holdings::StatisticsTab',
  DeployedTokens = 'DeployedTokens::StatisticsTab',
}
export const StatisticsTabs = [
  StatisticsTab.Trades,
  StatisticsTab.Holdings,
  StatisticsTab.DeployedTokens,
]
